module.exports = [[{"x":193,"y":88},{"x":193,"y":89},{"x":193,"y":91},{"x":193,"y":92},{"x":193,"y":93},{"x":193,"y":94},{"x":193,"y":96},{"x":193,"y":98},{"x":193,"y":104},{"x":193,"y":113},{"x":193,"y":122},{"x":193,"y":132},{"x":193,"y":141},{"x":193,"y":143},{"x":193,"y":144},{"x":193,"y":144}],[{"x":175,"y":108},{"x":176,"y":108},{"x":176,"y":108},{"x":177,"y":108},{"x":182,"y":108},{"x":190,"y":108},{"x":197,"y":108},{"x":201,"y":108},{"x":204,"y":108},{"x":204,"y":108},{"x":205,"y":108}]]


//////////////////
// WEBPACK FOOTER
// ./src/data/chinese/ten_templates.json
// module id = 147
// module chunks = 0